import { schema } from 'normalizr'

export const organization = new schema.Entity('organizations')
export const arrayOfOrganizations = new schema.Array(organization)



// WEBPACK FOOTER //
// ./src/adapters/dobovoOrganizationSchema.js